module.exports = __webpack_public_path__ + "static/media/join-in-img3-4.6c4f31d4.png";